import { ShieldX, Home, Lock, ArrowLeft, LogOut } from "lucide-react";
import axios from "axios";
import useAuthStore from "../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../Configurations/Urls";
import "./NotAllowed.css";

const NotAllowed = () => {
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        await axios.get(`${MAIN_URL}/api/auth/logout`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      // Continue local logout even if API call fails.
    }
    logout();
    window.location.replace("/login");
  };

  return (
    <div className="na-page">
      <div className="na-card">
        <div className="na-icon-wrap">
          <ShieldX className="na-icon" strokeWidth={2.25} />
        </div>

        <div className="na-code">403</div>
        <h1 className="na-title">Access Denied</h1>
        <p className="na-text">
          You don&apos;t have permission to access this resource. If you believe
          this is an error, please contact support.
        </p>

        <div className="na-locks" aria-hidden="true">
          <Lock size={14} strokeWidth={2} />
          <Lock size={14} strokeWidth={2} />
          <Lock size={14} strokeWidth={2} />
        </div>

        <div className="na-actions">
          <a href="/" className="na-btn na-btn-primary">
            <Home size={15} strokeWidth={2.25} />
            Go to Home
          </a>
          <button
            type="button"
            className="na-btn na-btn-muted"
            onClick={() => window.history.back()}
          >
            <ArrowLeft size={15} strokeWidth={2.25} />
            Go Back
          </button>
          <button
            type="button"
            className="na-btn na-btn-danger"
            onClick={handleLogout}
          >
            <LogOut size={15} strokeWidth={2.25} />
            Logout
          </button>
        </div>

        <p className="na-footer">
          Error Code: <span>ERR_FORBIDDEN</span>
        </p>
      </div>
    </div>
  );
};

export default NotAllowed;
